import { appEnv } from './app-env'
import { ITenant } from './app.interface'

interface ITenantConfig {
  webTitle: string
  logoPath: string
  faviconPath: string
}

export const tenantConfigs: Record<ITenant, ITenantConfig> = {
  blcp: {
    webTitle: 'BLCP IDP',
    logoPath: 'images/app-logo/blcp.webp',
    faviconPath: 'images/app-favicon/blcp.ico',
  },
  shera: {
    webTitle: 'SHERA IDP',
    logoPath: 'images/app-logo/shera.webp',
    faviconPath: 'images/app-favicon/shera.ico',
  },
  demo: {
    webTitle: 'IDP',
    logoPath: 'images/app-logo/demo.webp',
    faviconPath: 'images/app-favicon/demo.ico',
  },
}

export const tenantConfig = tenantConfigs[appEnv.tenant]
